var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PostDataWrapper',{attrs:{"count":1},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [(slotProps.lastPost.id)?_c('LatestPost',{class:_vm.className,attrs:{"post":slotProps.lastPost}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }